import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="bg-charcoal py-24 px-6 md:px-12" data-id="element-100">
      <div className="max-w-4xl mx-auto" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-amber/10 border-l-8 border-amber p-8 md:p-12 rounded-r-3xl" data-id="element-102">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-amber mb-6" data-id="element-103">
            El Cambio en 7 Días
          </h2>
          <p className="font-sans text-lg md:text-xl text-cream/90 leading-relaxed italic" data-id="element-104">
            "En una semana, vas a pasar de usar la AirFryer como un adorno caro
            a cocinar el 80% de tus cenas en ella. Vas a notar menos olor en la
            casa, menos gasto en delivery y, sobre todo, vas a volver a
            disfrutar de una milanesa jugosa un martes a la noche."
          </p>
        </motion.div>
      </div>
    </section>;
}